import(/* webpackMode: "eager" */ "/var/www/InfinityV1/app/blogs/[id]/page.tsx");
